/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { enableProdMode } from "@angular/core";
import "./polyfills";
import {environment} from "./environments/environment";


if (environment.production) {
  enableProdMode(); // <-- here
}
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));

  



